import {Card} from "../../../../../components/card/card.jsx";
import {FaFile, FaTimes} from "react-icons/fa";
import {iconsByType} from "../../utils/library-utils.js";
import LibraryTypeDocument from "./library-types/library-type-document.jsx";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import LibraryTypeFolder from "./library-types/library-type-folder.jsx";
import ProjectUtils from "../../../../../utils/project-utils.js";
import LibraryTypeFile from "./library-types/library-type-file.jsx";
import LibraryDetailsItem from "./library-details-item.jsx";

const getIconByType = (type) => {
    return iconsByType[type] ?? FaFile;
}

export default function LibraryPreview({ item, onClose }) {
    const navigate = navigateHook();

    if (!item) return null;

    const id = item.id;
    const Icon = getIconByType(item.type);

    const isDocument = item.type === "DOCUMENT";
    const isFolder = item.type === "FOLDER";
    const isFile = item.type === "FILE";

    const handleOpenDocument = () => {
        if (!isDocument) return;

        navigate(`/library/document/form/${id}`);
    }

    return (
        <Card className="w-[404px] h-[calc(100vh-132px)]">
            <Card.Body className="h-full min-h-0 p-4! overflow-auto">
                <div className="flex items-center justify-between gap-2 w-full min-w-0 overflow-hidden">
                    <div className="flex items-center gap-2 min-w-0 flex-1 overflow-hidden">
                        <Icon size={20} className="mb-1 shrink-0" />
                        <div className="min-w-0 flex-1 overflow-hidden">
                            <button
                                type="button"
                                title={item.name}
                                onClick={isDocument ? handleOpenDocument : undefined}
                                className={`
                                    block w-full truncate text-left text-[18px]! font-bold
                                    ${isDocument ? "cursor-pointer hover:underline" : "cursor-default"}
                                `}
                            >
                                {item.name}
                            </button>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex shrink-0 justify-center items-center rounded-md h-8 w-8 hover:bg-gray-100"
                    >
                        <FaTimes />
                    </button>
                </div>
                <section className="space-y-2 mt-2">
                    <h2 className="text-sm! font-bold">
                        Detalhes
                    </h2>
                    <LibraryDetailsItem>Criado por {item.userCreated} em {ProjectUtils.formatDate(item.createdAt)}</LibraryDetailsItem>
                    <LibraryDetailsItem>Última modificação por {item.userUpdated} em {ProjectUtils.formatDate(item.updatedAt)}</LibraryDetailsItem>
                    <LibraryDetailsItem>Pasta: {item.parentName ?? "Minha biblioteca"}</LibraryDetailsItem>
                </section>
                {isDocument && <LibraryTypeDocument item={item} />}
                {isFolder && <LibraryTypeFolder item={item} />}
                {isFile && <LibraryTypeFile item={item} />}
            </Card.Body>
        </Card>
    )
}